import { SignupDetailsPage } from '@/pages/signup-details';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/signup-details')({
	component: SignupDetailsPage,
});
